import React, { useEffect, useState } from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { TeacherApi } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";

interface IProps {
  onChange: (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => void;
  selectedKey?: string | number | null;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}
export default function TeachersDropdown(props: IProps) {
  const [teacherApi] = useState<TeacherApi>(new TeacherApi(getApiUrl()));
  const [teacherOptions, setTeacherOptions] = useState<IDropdownOption[]>([]);

  useEffect(() => {
    teacherApi.getAll(true).then((res) => {
      setTeacherOptions(
        (res ?? []).map((t) => ({
          key: t.teacherId ?? "",
          text: `${t.firstName ?? ""} ${t.lastName ?? ""}`.trim(),
        }))
      );
    });
  }, [teacherApi]);

  return (
    <Dropdown
      {...props}
      options={teacherOptions}
      style={{ width: "100%" }}
    />
  );
}

TeachersDropdown.defaultProps = {
  label: null,
  placeholder: null,
  required: false,
  disabled: false,
};
